/**
 * ez-jwt/v1 response schemas.
 *
 * Source of truth: GET /wp-json/ez-jwt/v1/openapi.json
 * Verified against live responses from dev.ez-qr.menu (see tests/unit/fixtures).
 */
import { z } from 'zod'

import { siteWire, userWire } from './common'

export const loginResponseSchema = z.object({
  access_token: z.string(),
  expires_in: z.number().int().positive(),
  /** Present only when `client: "mobile"` and `no_refresh: false`. */
  refresh_token: z.string().optional(),
  /** Present only when the response is stateless (no refresh). */
  mode: z.literal('stateless').optional(),
  user: userWire,
  sites: z.array(siteWire),
})
export type LoginResponse = z.infer<typeof loginResponseSchema>

export const refreshResponseSchema = z.object({
  access_token: z.string(),
  expires_in: z.number().int().positive(),
  /** Only for `client: "mobile"`; web reads it from the Set-Cookie. */
  refresh_token: z.string().optional(),
})
export type RefreshResponse = z.infer<typeof refreshResponseSchema>

export const meResponseSchema = z.object({
  user: userWire,
  sites: z.array(siteWire),
})
export type MeResponse = z.infer<typeof meResponseSchema>

export const logoutResponseSchema = z.object({
  ok: z.boolean(),
})
export type LogoutResponse = z.infer<typeof logoutResponseSchema>

/** Server error envelope: `{ code, message, ... }`. */
export const apiErrorBodySchema = z.object({
  code: z.string(),
  message: z.string(),
  /** Optional hints used by SSO 404 (`email_not_in_wp`, `manual_link_required`). */
  hint: z.string().optional(),
})
export type ApiErrorBody = z.infer<typeof apiErrorBodySchema>
